import { api } from './axios'
import type {
  CheckoutSessionStatusResponseDto,
  CreateCheckoutSessionDto,
  CreateCheckoutSessionResponseDto,
  FullPortalResponseDto,
  PlanUpdatePortalResponseDto,
  PlanUpdateRequestDto,
  PortalSessionResponseDto,
  ResumeSubscriptionPortalResponseDto,
  StripeProductsResponseDto,
  SubscriptionCancellationPortalResponseDto,
} from './types'

// Create a billing checkout session
export const createCheckoutSession = async (
  data: CreateCheckoutSessionDto,
): Promise<CreateCheckoutSessionResponseDto> => {
  const response = await api.post('/billing/checkout-session', data)

  return response.data
}

// Get checkout session status
export const getCheckoutSessionStatus = async (
  sessionId: string,
): Promise<CheckoutSessionStatusResponseDto> => {
  const response = await api.get(`/billing/checkout-session/${sessionId}/status`)

  return response.data
}

// Create a Stripe Customer Portal session
export const createPortalSession = async (): Promise<PortalSessionResponseDto> => {
  const response = await api.post('/billing/portal-session')

  return response.data
}

// Get stripe products
export const getStripeProducts = async (): Promise<StripeProductsResponseDto> => {
  const response = await api.get('/billing/stripe-products')

  return response.data
}

// Create subscription cancellation portal session
export const createSubscriptionCancellationPortal =
  async (): Promise<SubscriptionCancellationPortalResponseDto> => {
    const response = await api.post('/billing/subscription/cancel-portal')

    return response.data
  }

// Create subscription resume portal session
export const createResumeSubscriptionPortalSession =
  async (): Promise<ResumeSubscriptionPortalResponseDto> => {
    const response = await api.post('/billing/subscription/resume-portal')

    return response.data
  }

// Create full subscription management portal session
export const createFullPortalSession = async (): Promise<FullPortalResponseDto> => {
  const response = await api.post('/billing/subscription/full-portal')

  return response.data
}

// Create plan update portal session
export const createPlanUpdatePortalSession = async (
  data: PlanUpdateRequestDto,
): Promise<PlanUpdatePortalResponseDto> => {
  const response = await api.post('/billing/subscription/plan-update-portal', data)

  return response.data
}
